import methods from "./methods.png"


const checkoutAssets = {
    methods
}

export default checkoutAssets